"use strict";
/**
 * MailchimpInterface.ts
 * Interface used to strongly typed the mailchimp object
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=MailchimpInterface.js.map